/*
 * @File Name: import.meta.glob 读取多语言目录所有多语言配置
 * @Author: zhuzhaoyang
 * @Date: 2023-06-13 13:30:28
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-09-17 20:04:17
 * @Description: 
 * @FilePath: /src/global/i18n/lang-pack/en.ts
 */
// const files = import.meta.glob('@/lang/en/*.json');
const langConfig: any = {};
// for (const path in files) {
//   const module = await files[path]()
//   const config = (module as any).default;
//   langConfig = Object.assign(langConfig, config);
// }
export default langConfig;